import { TechnicianRegionDto } from '@shared/models/technician/technician.model';
import { escapeHtml } from '@shared/utilities/html.util';
import { escapeHtmlAttribute } from '@shared/utilities/statement-anomaly.util';

export const TECHNICIAN_ROSTER_MAX_VISIBLE_REGIONS = 2;

export function getTechnicianRegionNames(
  regions: TechnicianRegionDto[] | undefined | null,
): string[] {
  return (regions ?? [])
    .map((region) => region.regionName?.trim())
    .filter((name): name is string => Boolean(name));
}

export function formatTechnicianRegionLabels(
  regions: TechnicianRegionDto[] | undefined | null,
): string {
  return getTechnicianRegionNames(regions).join(', ');
}

function buildRemainingRegionsTooltip(regionNames: string[]): string {
  const items = regionNames.map((name) => `<li>${escapeHtml(name)}</li>`).join('');
  return `<ul>${items}</ul>`;
}

export function renderTechnicianRegionsCell(
  regions: TechnicianRegionDto[] | undefined | null,
): string {
  const regionNames = getTechnicianRegionNames(regions);

  if (!regionNames.length) {
    return '—';
  }

  if (regionNames.length <= TECHNICIAN_ROSTER_MAX_VISIBLE_REGIONS) {
    return regionNames.map((name) => escapeHtml(name)).join(', ');
  }

  const visibleNames = regionNames.slice(0, TECHNICIAN_ROSTER_MAX_VISIBLE_REGIONS);
  const remainingNames = regionNames.slice(TECHNICIAN_ROSTER_MAX_VISIBLE_REGIONS);
  const visibleText = visibleNames.map((name) => escapeHtml(name)).join(', ');
  const tooltipHtml = buildRemainingRegionsTooltip(remainingNames);

  return `${visibleText} <span data-column="tooltip" style="font-weight: 600; cursor: pointer;" tooltip-text="${escapeHtmlAttribute(tooltipHtml)}">+${remainingNames.length}</span>`;
}
